import React, { useEffect, useRef, useState } from 'react';

// Chrome do Android não renderiza PDF dentro de <iframe> (mostra só "Abrir").
// Aqui as páginas são desenhadas em <canvas> com pdf.js.
export const precisaPdfCanvas = () =>
  /Android/i.test(navigator.userAgent) && navigator.pdfViewerEnabled !== true;

const PdfCanvasViewer = ({ url }) => {
  const containerRef = useRef(null);
  const [erro, setErro] = useState(false);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    let cancelado = false;
    let doc = null;

    (async () => {
      try {
        const pdfjs = await import('pdfjs-dist');
        const worker = await import('pdfjs-dist/build/pdf.worker.min.mjs?url');
        pdfjs.GlobalWorkerOptions.workerSrc = worker.default;

        const buffer = await (await fetch(url)).arrayBuffer();
        doc = await pdfjs.getDocument({ data: buffer }).promise;
        const container = containerRef.current;
        if (cancelado || !container) return;
        container.innerHTML = '';

        const largura = container.clientWidth || window.innerWidth;
        const dpr = Math.min(window.devicePixelRatio || 1, 2);

        for (let n = 1; n <= doc.numPages; n++) {
          const page = await doc.getPage(n);
          if (cancelado) return;
          const base = page.getViewport({ scale: 1 });
          const escala = largura / base.width;
          const viewport = page.getViewport({ scale: escala * dpr });

          const canvas = document.createElement('canvas');
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          canvas.style.width = `${largura}px`;
          canvas.style.height = `${viewport.height / dpr}px`;
          canvas.style.display = 'block';
          canvas.style.marginBottom = '8px';
          canvas.style.background = '#fff';
          container.appendChild(canvas);

          await page.render({ canvasContext: canvas.getContext('2d'), viewport }).promise;
          if (n === 1) setCarregando(false);
        }
        setCarregando(false);
      } catch (e) {
        console.error('Erro ao renderizar PDF:', e);
        if (!cancelado) { setErro(true); setCarregando(false); }
      }
    })();

    return () => { cancelado = true; if (doc) doc.destroy(); };
  }, [url]);

  if (erro) {
    return <div className="flex items-center justify-center h-full text-gray-500 p-4 text-center">Não foi possível exibir o preview. Use o botão de baixar PDF.</div>;
  }

  return (
    <div className="h-full overflow-auto bg-gray-200">
      {carregando && <p className="text-center text-gray-500 py-6">Carregando preview...</p>}
      <div ref={containerRef} />
    </div>
  );
};

export default PdfCanvasViewer;
